export const HandleType = {
  GIFT_CARD: "gift-card",
  ORDER_PROTECTION: "navidium-shipping-protection",
  SUBSCRIPTION: "al-luxe",
  FLOATING_ATC_UPSELL_PRODUCT: "the-daily-case",
  // Keep in sync with CancelSubscriptionPerkPicker product title
  LUXE_RETENTION_GIFT: "the-daily-case",
};
